import { initialState } from "./state"

export default {
  setCep: (state, cep) => (state.cep = cep),
  setAddress: (state, address) => (state.address = address),
  setNumber: (state, number) => (state.number = number),
  setNoNumber: (state, noNumber) => (state.noNumber = noNumber),
  setNeighborhood: (state, neighborhood) => (state.neighborhood = neighborhood),
  setState: (state, value) => (state.state = value),
  setCity: (state, city) => (state.city = city),
  setComplements: (state, complements) => (state.complements = complements),
  setNoComplement: (state, noComplement) => (state.noComplement = noComplement),
  setAddressNote: (state, addressNote) => (state.addressNote = addressNote),

  resetAddress: state => {
    const init_state = initialState()
    Object.keys(state).forEach(key => {
      state[key] = init_state[key]
    })
  }
}
